<template>
  <div class="mt-4 student-detail-card-top">
    <v-tabs v-model="tab" vertical hide-slider class="custom-tab-tutor">
      <v-tab v-for="item in tabs" :key="item.tab">
        <v-row>
          <v-col cols="2"
            ><img
              :src="tab === item.key ? icons.active : icons.deactive"
              alt=""
          /></v-col>
          <v-col cols="10" style="font-size: 12px"><div v-html="item.text"></div></v-col>
        </v-row>
      </v-tab>
      <template v-if="activeCurriculumId !== 0">
        <v-tab-item>
          <daily-log></daily-log>
        </v-tab-item>
        <v-tab-item>
          <ExerciseTutorTab/>
        </v-tab-item>
        <v-tab-item>
          <test-tab-tutor/>
        </v-tab-item>
        <v-tab-item>
          <Diligence />
        </v-tab-item>
      </template>
      <template v-else>
        <!--        Tab bài luyện tập và tương tác-->
        <v-tab-item>
          <TutorSelfStudy></TutorSelfStudy>
        </v-tab-item>
        <v-tab-item>
          <SelfStudyTest></SelfStudyTest>
        </v-tab-item>
      </template>
    </v-tabs>
  </div>
</template>

<script>
import SelfStudyTest
from '@/modules/student_detail_bt/components/StudentBulletinBoard/SelfStudyTest.vue';
import TestTabTutor from '@/modules/student_detail_bt/components/StudentBulletinBoard/TestTabTutor.vue';
import ExerciseTutorTab from '@/modules/student_detail_bt/components/StudentBulletinBoard/ExerciseTutorTab.vue';
import { mapState } from 'vuex';
import DailyLog from './DailyLog.vue';
import Diligence from './Diligence.vue';
import TutorSelfStudy from './TutorSelfStudy.vue';

export default {
  components: {
    DailyLog, TestTabTutor, Diligence, ExerciseTutorTab, SelfStudyTest, TutorSelfStudy,
  },
  data() {
    return {
      icons: { active: '/img/active.png', deactive: '/img/deactive.png' },
      items: [
        {
          key: 0,
          text: '<span>Bảng tin <br/> học viên</span>',
        },
        {
          key: 1,
          text: '<span>Bài luyện tập <br/> & tương tác</span>',
        },
        {
          key: 2,
          text: '<span>Kiểm tra</span>',
        },
        {
          key: 3,
          text: '<span>Chuyên cần</span>',
        },
      ],
      tab: 0,
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['activeCurriculumId']),
    tabs() {
      if (this.activeCurriculumId === 0) {
        return [
          {
            key: 0,
            text: '<span>Bài tập về nhà</span>',
          },
          {
            key: 1,
            text: '<span>Kiểm tra</span>',
          },
        ];
      } return [
        {
          key: 0,
          text: '<span>Bảng tin <br/> học viên</span>',
        },
        {
          key: 1,
          text: '<span>Bài luyện tập <br/> & tương tác</span>',
        },
        {
          key: 2,
          text: '<span>Kiểm tra</span>',
        },
        {
          key: 3,
          text: '<span>Chuyên cần</span>',
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.student-detail-card-top {
  width: 98%;
  border-radius: 12px;
  background: white;
  padding: 16px;
}
.custom-tab-tutor .v-slide-group__content.v-tabs-bar__content {
  background: white;
}
.custom-tab-tutor .v-tab.v-tab--active {
  background: #E3F0FF;
  color: black;
  filter: none;
}
.custom-tab-tutor .v-tab {
  filter: grayscale(1);
  border-radius: 10px;
  max-width: 200px !important;
  justify-content: left;
  margin-bottom: 12px;
  background: #F8F7F7;
}
.custom-tab-tutor .v-slide-group__content {
  white-space: normal !important;
}
.custom-tab-tutor .v-tabs-items {
  margin-left: 45px;
}
@media screen and (max-width: 1440px) {
  .student-detail-card-top {
    font-size: 12px !important;
    span {
      font-size: 12px !important;
    }
  }
  .custom-tab-tutor .v-tabs-items {
    margin-left: 0px;
  }
}
</style>
